import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db, dbAccounts } from "../../../backend/firebaseConfig";

const FEES_COLLECTION = "Fees";
const ADVISERS_PATH = ["Authorized Members", "Advisers", "Data"];

const normaliseEmail = (value) => String(value || "").trim().toLowerCase();
const normaliseIds = (value) => {
  const values = Array.isArray(value) ? value : [value];
  return [...new Set(values.map((id) => String(id ?? "").trim()).filter(Boolean))];
};

export const loadSellingAdviserIds = async (userEmail) => {
  const email = normaliseEmail(userEmail);
  if (!email) return [];

  const advisers = await getDocs(collection(db, ...ADVISERS_PATH));
  const adviser = advisers.docs.find((item) => {
    const data = item.data() || {};
    return normaliseEmail(data.email || item.id) === email;
  });
  if (!adviser) return [];

  const ioDetails = await getDoc(
    doc(db, ...ADVISERS_PATH, adviser.id, "IO Details", "Data"),
  );
  if (!ioDetails.exists()) return [];

  const details = ioDetails.data() || {};
  return normaliseIds(details.id ?? details.ioAdviserId);
};

export const subscribeFees = ({ isAdmin, sellingAdviserIds }, onData, onError) => {
  const fees = collection(dbAccounts, FEES_COLLECTION);

  if (isAdmin) {
    return onSnapshot(
      fees,
      (snapshot) =>
        onData(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))),
      onError,
    );
  }

  const ids = normaliseIds(sellingAdviserIds);
  if (!ids.length) {
    onData([]);
    return () => {};
  }

  const chunks = [];
  for (let index = 0; index < ids.length; index += 30) {
    chunks.push(ids.slice(index, index + 30));
  }

  const results = new Map();
  const unsubs = chunks.map((idChunk, chunkIndex) =>
    onSnapshot(
      query(fees, where("sellingAdviserId", "in", idChunk)),
      (snapshot) => {
        results.set(
          chunkIndex,
          snapshot.docs.map((item) => ({ id: item.id, ...item.data() })),
        );
        onData([...results.values()].flat());
      },
      onError,
    ),
  );

  return () => unsubs.forEach((unsubscribe) => unsubscribe());
};
